export default __webpack_public_path__ + "static/media/property_624.49094cff.png";